"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Accessorial = _interopRequireDefault(require("./Accessorial"));

var _EquipmentType = _interopRequireDefault(require("./EquipmentType"));

var _ShipmentLineItem = _interopRequireDefault(require("./ShipmentLineItem"));

var _ShipmentMode = _interopRequireDefault(require("./ShipmentMode"));

var _SlimCompany = _interopRequireDefault(require("./SlimCompany"));

var _Stop = _interopRequireDefault(require("./Stop"));

var _TenderGet = _interopRequireDefault(require("./TenderGet"));

var _TotalWeightOverride = _interopRequireDefault(require("./TotalWeightOverride"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The LoadBoardShipment model module.
 * @module model/LoadBoardShipment
 * @version 2.7.64
 */
var LoadBoardShipment = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>LoadBoardShipment</code>.
   * @alias module:model/LoadBoardShipment
   * @param accessorials {Array.<module:model/Accessorial>} 
   * @param biddingStatus {module:model/LoadBoardShipment.BiddingStatusEnum} 
   * @param customer {module:model/SlimCompany} 
   * @param id {String} 
   * @param lineItems {Array.<module:model/ShipmentLineItem>} 
   * @param loadBoardId {String} 
   * @param state {module:model/LoadBoardShipment.StateEnum} 
   * @param stops {Array.<module:model/Stop>} 
   */
  function LoadBoardShipment(accessorials, biddingStatus, customer, id, lineItems, loadBoardId, state, stops) {
    _classCallCheck(this, LoadBoardShipment);

    LoadBoardShipment.initialize(this, accessorials, biddingStatus, customer, id, lineItems, loadBoardId, state, stops);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(LoadBoardShipment, null, [{
    key: "initialize",
    value: function initialize(obj, accessorials, biddingStatus, customer, id, lineItems, loadBoardId, state, stops) {
      obj['accessorials'] = accessorials;
      obj['bidding_status'] = biddingStatus;
      obj['customer'] = customer;
      obj['id'] = id;
      obj['line_items'] = lineItems;
      obj['load_board_id'] = loadBoardId;
      obj['state'] = state;
      obj['stops'] = stops;
    }
    /**
     * Constructs a <code>LoadBoardShipment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LoadBoardShipment} obj Optional instance to populate.
     * @return {module:model/LoadBoardShipment} The populated <code>LoadBoardShipment</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new LoadBoardShipment();

        if (data.hasOwnProperty('accessorials')) {
          obj['accessorials'] = _ApiClient["default"].convertToType(data['accessorials'], [_Accessorial["default"]]);
        }

        if (data.hasOwnProperty('bid_count')) {
          obj['bid_count'] = _ApiClient["default"].convertToType(data['bid_count'], 'Number');
        }

        if (data.hasOwnProperty('bidding_status')) {
          obj['bidding_status'] = _ApiClient["default"].convertToType(data['bidding_status'], 'String');
        }

        if (data.hasOwnProperty('buy_it_now_amount')) {
          obj['buy_it_now_amount'] = _ApiClient["default"].convertToType(data['buy_it_now_amount'], 'Number');
        }

        if (data.hasOwnProperty('buy_it_now_amount_currency')) {
          obj['buy_it_now_amount_currency'] = _ApiClient["default"].convertToType(data['buy_it_now_amount_currency'], 'String');
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('customer')) {
          obj['customer'] = _SlimCompany["default"].constructFromObject(data['customer']);
        }

        if (data.hasOwnProperty('customer_reference_number')) {
          obj['customer_reference_number'] = _ApiClient["default"].convertToType(data['customer_reference_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_booking_number')) {
          obj['drayage_booking_number'] = _ApiClient["default"].convertToType(data['drayage_booking_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_chassis_number')) {
          obj['drayage_chassis_number'] = _ApiClient["default"].convertToType(data['drayage_chassis_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_container_number')) {
          obj['drayage_container_number'] = _ApiClient["default"].convertToType(data['drayage_container_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_container_return_date')) {
          obj['drayage_container_return_date'] = _ApiClient["default"].convertToType(data['drayage_container_return_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_estimated_arrival_date')) {
          obj['drayage_estimated_arrival_date'] = _ApiClient["default"].convertToType(data['drayage_estimated_arrival_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_last_free_date')) {
          obj['drayage_last_free_date'] = _ApiClient["default"].convertToType(data['drayage_last_free_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_release_date')) {
          obj['drayage_release_date'] = _ApiClient["default"].convertToType(data['drayage_release_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_seal_number')) {
          obj['drayage_seal_number'] = _ApiClient["default"].convertToType(data['drayage_seal_number'], 'String');
        }

        if (data.hasOwnProperty('equipment_types')) {
          obj['equipment_types'] = _ApiClient["default"].convertToType(data['equipment_types'], [_EquipmentType["default"]]);
        }

        if (data.hasOwnProperty('expires_at')) {
          obj['expires_at'] = _ApiClient["default"].convertToType(data['expires_at'], 'Date');
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('is_tendered')) {
          obj['is_tendered'] = _ApiClient["default"].convertToType(data['is_tendered'], 'Boolean');
        }

        if (data.hasOwnProperty('line_items')) {
          obj['line_items'] = _ApiClient["default"].convertToType(data['line_items'], [_ShipmentLineItem["default"]]);
        }

        if (data.hasOwnProperty('load_board_id')) {
          obj['load_board_id'] = _ApiClient["default"].convertToType(data['load_board_id'], 'String');
        }

        if (data.hasOwnProperty('lowest_bid_amount')) {
          obj['lowest_bid_amount'] = _ApiClient["default"].convertToType(data['lowest_bid_amount'], 'Number');
        }

        if (data.hasOwnProperty('lowest_bids')) {
          obj['lowest_bids'] = _ApiClient["default"].convertToType(data['lowest_bids'], ['Number']);
        }

        if (data.hasOwnProperty('modes')) {
          obj['modes'] = _ApiClient["default"].convertToType(data['modes'], [_ShipmentMode["default"]]);
        }

        if (data.hasOwnProperty('notes_for_carrier')) {
          obj['notes_for_carrier'] = _ApiClient["default"].convertToType(data['notes_for_carrier'], 'String');
        }

        if (data.hasOwnProperty('preferred_currency')) {
          obj['preferred_currency'] = _ApiClient["default"].convertToType(data['preferred_currency'], 'String');
        }

        if (data.hasOwnProperty('spot_negotiation')) {
          obj['spot_negotiation'] = _ApiClient["default"].convertToType(data['spot_negotiation'], 'String');
        }

        if (data.hasOwnProperty('spot_negotiation_carrier_status')) {
          obj['spot_negotiation_carrier_status'] = _ApiClient["default"].convertToType(data['spot_negotiation_carrier_status'], 'String');
        }

        if (data.hasOwnProperty('state')) {
          obj['state'] = _ApiClient["default"].convertToType(data['state'], 'String');
        }

        if (data.hasOwnProperty('stops')) {
          obj['stops'] = _ApiClient["default"].convertToType(data['stops'], [_Stop["default"]]);
        }

        if (data.hasOwnProperty('temperature_lower_limit')) {
          obj['temperature_lower_limit'] = _ApiClient["default"].convertToType(data['temperature_lower_limit'], 'Number');
        }

        if (data.hasOwnProperty('temperature_upper_limit')) {
          obj['temperature_upper_limit'] = _ApiClient["default"].convertToType(data['temperature_upper_limit'], 'Number');
        }

        if (data.hasOwnProperty('tenders')) {
          obj['tenders'] = _ApiClient["default"].convertToType(data['tenders'], [_TenderGet["default"]]);
        }

        if (data.hasOwnProperty('total_declared_value')) {
          obj['total_declared_value'] = _ApiClient["default"].convertToType(data['total_declared_value'], 'Number');
        }

        if (data.hasOwnProperty('total_declared_value_currency')) {
          obj['total_declared_value_currency'] = _ApiClient["default"].convertToType(data['total_declared_value_currency'], 'String');
        }

        if (data.hasOwnProperty('total_miles')) {
          obj['total_miles'] = _ApiClient["default"].convertToType(data['total_miles'], 'Number');
        }

        if (data.hasOwnProperty('total_weight_override')) {
          obj['total_weight_override'] = _TotalWeightOverride["default"].constructFromObject(data['total_weight_override']);
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }
      }

      return obj;
    }
  }]);

  return LoadBoardShipment;
}();
/**
 * @member {Array.<module:model/Accessorial>} accessorials
 */


LoadBoardShipment.prototype['accessorials'] = undefined;
/**
 * @member {Number} bid_count
 */

LoadBoardShipment.prototype['bid_count'] = undefined;
/**
 * @member {module:model/LoadBoardShipment.BiddingStatusEnum} bidding_status
 */

LoadBoardShipment.prototype['bidding_status'] = undefined;
/**
 * @member {Number} buy_it_now_amount
 */

LoadBoardShipment.prototype['buy_it_now_amount'] = undefined;
/**
 * @member {module:model/LoadBoardShipment.BuyItNowAmountCurrencyEnum} buy_it_now_amount_currency
 */

LoadBoardShipment.prototype['buy_it_now_amount_currency'] = undefined;
/**
 * @member {Date} created_at
 */

LoadBoardShipment.prototype['created_at'] = undefined;
/**
 * @member {module:model/SlimCompany} customer
 */

LoadBoardShipment.prototype['customer'] = undefined;
/**
 * @member {String} customer_reference_number
 */

LoadBoardShipment.prototype['customer_reference_number'] = undefined;
/**
 * @member {String} drayage_booking_number
 */

LoadBoardShipment.prototype['drayage_booking_number'] = undefined;
/**
 * @member {String} drayage_chassis_number
 */

LoadBoardShipment.prototype['drayage_chassis_number'] = undefined;
/**
 * @member {String} drayage_container_number
 */

LoadBoardShipment.prototype['drayage_container_number'] = undefined;
/**
 * @member {String} drayage_container_return_date
 */

LoadBoardShipment.prototype['drayage_container_return_date'] = undefined;
/**
 * @member {String} drayage_estimated_arrival_date
 */

LoadBoardShipment.prototype['drayage_estimated_arrival_date'] = undefined;
/**
 * @member {String} drayage_last_free_date
 */

LoadBoardShipment.prototype['drayage_last_free_date'] = undefined;
/**
 * @member {String} drayage_release_date
 */

LoadBoardShipment.prototype['drayage_release_date'] = undefined;
/**
 * @member {String} drayage_seal_number
 */

LoadBoardShipment.prototype['drayage_seal_number'] = undefined;
/**
 * @member {Array.<module:model/EquipmentType>} equipment_types
 */

LoadBoardShipment.prototype['equipment_types'] = undefined;
/**
 * @member {Date} expires_at
 */

LoadBoardShipment.prototype['expires_at'] = undefined;
/**
 * @member {String} id
 */

LoadBoardShipment.prototype['id'] = undefined;
/**
 * @member {Boolean} is_tendered
 */

LoadBoardShipment.prototype['is_tendered'] = undefined;
/**
 * @member {Array.<module:model/ShipmentLineItem>} line_items
 */

LoadBoardShipment.prototype['line_items'] = undefined;
/**
 * @member {String} load_board_id
 */

LoadBoardShipment.prototype['load_board_id'] = undefined;
/**
 * @member {Number} lowest_bid_amount
 */

LoadBoardShipment.prototype['lowest_bid_amount'] = undefined;
/**
 * @member {Array.<Number>} lowest_bids
 */

LoadBoardShipment.prototype['lowest_bids'] = undefined;
/**
 * @member {Array.<module:model/ShipmentMode>} modes
 */

LoadBoardShipment.prototype['modes'] = undefined;
/**
 * @member {String} notes_for_carrier
 */

LoadBoardShipment.prototype['notes_for_carrier'] = undefined;
/**
 * @member {String} preferred_currency
 */

LoadBoardShipment.prototype['preferred_currency'] = undefined;
/**
 * @member {String} spot_negotiation
 */

LoadBoardShipment.prototype['spot_negotiation'] = undefined;
/**
 * @member {module:model/LoadBoardShipment.SpotNegotiationCarrierStatusEnum} spot_negotiation_carrier_status
 */

LoadBoardShipment.prototype['spot_negotiation_carrier_status'] = undefined;
/**
 * @member {module:model/LoadBoardShipment.StateEnum} state
 */

LoadBoardShipment.prototype['state'] = undefined;
/**
 * @member {Array.<module:model/Stop>} stops
 */

LoadBoardShipment.prototype['stops'] = undefined;
/**
 * @member {Number} temperature_lower_limit
 */

LoadBoardShipment.prototype['temperature_lower_limit'] = undefined;
/**
 * @member {Number} temperature_upper_limit
 */

LoadBoardShipment.prototype['temperature_upper_limit'] = undefined;
/**
 * @member {Array.<module:model/TenderGet>} tenders
 */

LoadBoardShipment.prototype['tenders'] = undefined;
/**
 * @member {Number} total_declared_value
 */

LoadBoardShipment.prototype['total_declared_value'] = undefined;
/**
 * @member {module:model/LoadBoardShipment.TotalDeclaredValueCurrencyEnum} total_declared_value_currency
 */

LoadBoardShipment.prototype['total_declared_value_currency'] = undefined;
/**
 * @member {Number} total_miles
 */

LoadBoardShipment.prototype['total_miles'] = undefined;
/**
 * @member {module:model/TotalWeightOverride} total_weight_override
 */

LoadBoardShipment.prototype['total_weight_override'] = undefined;
/**
 * @member {Date} updated_at
 */

LoadBoardShipment.prototype['updated_at'] = undefined;
/**
 * Allowed values for the <code>bidding_status</code> property.
 * @enum {String}
 * @readonly
 */

LoadBoardShipment['BiddingStatusEnum'] = {
  /**
   * value: "bidding"
   * @const
   */
  "bidding": "bidding",

  /**
   * value: "closed"
   * @const
   */
  "closed": "closed",

  /**
   * value: "open"
   * @const
   */
  "open": "open",

  /**
   * value: "won"
   * @const
   */
  "won": "won",

  /**
   * value: "tendered"
   * @const
   */
  "tendered": "tendered",

  /**
   * value: "accepted"
   * @const
   */
  "accepted": "accepted",

  /**
   * value: "rejected"
   * @const
   */
  "rejected": "rejected",

  /**
   * value: "expired"
   * @const
   */
  "expired": "expired"
};
/**
 * Allowed values for the <code>buy_it_now_amount_currency</code> property.
 * @enum {String}
 * @readonly
 */

LoadBoardShipment['BuyItNowAmountCurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>spot_negotiation_carrier_status</code> property.
 * @enum {String}
 * @readonly
 */

LoadBoardShipment['SpotNegotiationCarrierStatusEnum'] = {
  /**
   * value: "ACTIVE"
   * @const
   */
  "ACTIVE": "ACTIVE",

  /**
   * value: "INACTIVE"
   * @const
   */
  "INACTIVE": "INACTIVE",

  /**
   * value: "DO_NOT_USE"
   * @const
   */
  "DO_NOT_USE": "DO_NOT_USE"
};
/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */

LoadBoardShipment['StateEnum'] = {
  /**
   * value: "appointment_pending"
   * @const
   */
  "appointment_pending": "appointment_pending",

  /**
   * value: "at_pickup"
   * @const
   */
  "at_pickup": "at_pickup",

  /**
   * value: "at_delivery"
   * @const
   */
  "at_delivery": "at_delivery",

  /**
   * value: "auction_running"
   * @const
   */
  "auction_running": "auction_running",

  /**
   * value: "cancelled"
   * @const
   */
  "cancelled": "cancelled",

  /**
   * value: "carrier_confirmed"
   * @const
   */
  "carrier_confirmed": "carrier_confirmed",

  /**
   * value: "delayed"
   * @const
   */
  "delayed": "delayed",

  /**
   * value: "delivered"
   * @const
   */
  "delivered": "delivered",

  /**
   * value: "dispatched"
   * @const
   */
  "dispatched": "dispatched",

  /**
   * value: "draft"
   * @const
   */
  "draft": "draft",

  /**
   * value: "in_transit"
   * @const
   */
  "in_transit": "in_transit",

  /**
   * value: "out_for_delivery"
   * @const
   */
  "out_for_delivery": "out_for_delivery",

  /**
   * value: "quote_accepted"
   * @const
   */
  "quote_accepted": "quote_accepted",

  /**
   * value: "quoting"
   * @const
   */
  "quoting": "quoting",

  /**
   * value: "reconciled"
   * @const
   */
  "reconciled": "reconciled",

  /**
   * value: "scheduled"
   * @const
   */
  "scheduled": "scheduled",

  /**
   * value: "tendered"
   * @const
   */
  "tendered": "tendered"
};
/**
 * Allowed values for the <code>total_declared_value_currency</code> property.
 * @enum {String}
 * @readonly
 */

LoadBoardShipment['TotalDeclaredValueCurrencyEnum'] = {
  /**
   * value: "USD"
   * @const
   */
  "USD": "USD",

  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD"
};
var _default = LoadBoardShipment;
exports["default"] = _default;